import StepNoCompatible from "./StepNoCompatible";

export default StepNoCompatible;